import { render, staticRenderFns } from "./ar.vue?vue&type=template&id=c4673760"
import script from "./ar.vue?vue&type=script&lang=js"
export * from "./ar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports